import { MAIL_MICROSOFT_OAUTH_ENABLED } from "@/lib/constants/microsoftOAuth";
import type { MailAccountSummary } from "@/lib/types/mail";

export function isMicrosoftMailAccount(
  account: Pick<MailAccountSummary, "authType" | "providerId"> | null | undefined
): boolean {
  if (account == null) return false;
  if (account.authType === "oauth_microsoft") return true;
  return account.providerId === "microsoft";
}

/**
 * Compte Microsoft OAuth à suspendre (pas de sync IMAP) — uniquement tant que OAuth est OFF.
 */
export function isMicrosoftOAuthMailAccount(account: MailAccountSummary): boolean {
  if (MAIL_MICROSOFT_OAUTH_ENABLED) return false;
  return account.authType === "oauth_microsoft";
}
